import React, { useState } from 'react';
import sizeFontCustom from '../../Discovery/fontSize.styles';
import {
	ListItemIcon,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Field = ({
	property,
	value,
	customDetails,
	tooltipText,
	children,
	styles,
	valueStyles,
	popoverComponent,
}) => {
	//Themeing
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [openToolTip, setOpenToolTip] = useState(false);
	
	// Check for dark theme - using your established pattern
	const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	const handleClick = () => {
		setOpenToolTip((prevState) => !prevState);
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'column', ...styles }}>
			{tooltipText ? (
				<div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
					<Typography
						sx={{
							...sizeFontCustom.consentField,
							maxWidth: mobileScreen ? '60vw' : '19vw',
							fontFamily: customDetails?.fontFamily,
							textAlign: 'left',
							fontWeight: 700,
							color: customDetails?.primaryTextColor ?? (isDark ? '#FFFFFF' : '#000000')
						}}
					>
						{property}
					</Typography>
					{popoverComponent ? (
						popoverComponent
					) : (
						<Tooltip
							open={openToolTip}
							title={tooltipText}
							onClick={handleClick}
						>
							<ListItemIcon>
								<InfoOutlinedIcon color="primary" sx={{ fontSize: 16 }} />
							</ListItemIcon>
						</Tooltip>
					)}
				</div>
			) : (
				<Typography
					sx={{
						...sizeFontCustom.consentField,
						maxWidth: mobileScreen ? '60vw' : '19vw',
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
						fontWeight: 700,
						color: customDetails?.primaryTextColor ?? (isDark ? '#FFFFFF' : '#000000')
					}}
				>
					{property}
				</Typography>
			)}
			{children || (
				<Typography
					sx={{
						...sizeFontCustom.cardText,
						maxWidth: mobileScreen ? '60vw' : '19vw',
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
						...valueStyles,
						color: customDetails?.secondaryTextColor ?? (isDark ? '#81858F' : '#000000')
					}}
				>
					{value}
				</Typography>
			)}
		</div>
	);
};

export default Field;
